import { ComponentType, lazy, Suspense } from 'react';

import { Loader } from '@/shared/ui/Loader';

interface LazyTabContentProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: () => Promise<{ default: ComponentType<any> }>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props?: Record<string, any>;
}

export const LazyTabContent = ({ component, props }: LazyTabContentProps) => {
  const LazyComponent = lazy(component);

  return (
    <Suspense fallback={<Loader containerSize="medium" />}>
      <LazyComponent {...props} />
    </Suspense>
  );
};
